import { useEffect, useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import { useAppDispatch, useAppSelector } from '@/redux';
import { useServices } from '@/services/useServices';
import { NS } from '@/constants';
import { getWineboxName, getAttributeValue, getAttributeId } from '@/utils/productUtils';
import { getIsCustomizable } from '@/utils/customizationUtils';
import { getApiErrorMessage } from '@/utils/millesimaUtils';

import { addCartProductClear } from '@/redux/slices/cart.slice';
import { refreshCategData } from '@/redux/slices/categ.slice';
import { addBoxProductClear } from '@/redux/slices/box.slice';
import { showAlertModal, showRecommendationModal } from '@/redux/slices/gui.slice';
import { CART_TYPE } from '@/constants/cart';
import { ATTRIBUTES } from '@/constants/product';

export const CartAndBoxEventsProcess = () => {
  const { t } = useTranslation(NS.COMMON);
  // const { datalayerService } = useServices();
  const dispatch = useAppDispatch();
  const cart = useAppSelector(({ cart }) => cart);
  const box = useAppSelector(({ box }) => box);

  // TODO: séparer cette fonction en plusieurs morceaux
  const processAddStatus = useCallback((entity) => {
    const { error, success } = entity.status.add || {};

    if (error) {
      const { errorCode, productName, limitEquivBtl } = error.error || error;
      if (errorCode === '1010') {
        dispatch(showAlertModal({
          content: getApiErrorMessage(t, error)
            .replace('{0}', productName)
            .replace('{1}', limitEquivBtl)
            .replace('{2}', limitEquivBtl * 0.75)
        }));
      } else {
        dispatch(showAlertModal({
          content: getApiErrorMessage(t, error),
          button: 'product.continueShopping'
        }));
      }
      return true;
    }

    if (!success || entity.diff.length === 0) {
      // Nothing to do or nothing changed in the cart
      return false;
    }

    const { content, diff } = entity;
    const [found] = diff;
    const { diffPartnumber, diffQty } = found;
    const isWineBox = content.wineBox;

    let key;

    if (diffQty > 0) {
      key = isWineBox ? 'addedToWinebox' : 'addedToCart';
    } else {
      key = isWineBox ? 'removedFromWinebox' : 'removedFromCart';
    }

    if (key === 'removedFromCart' && found?.wineBox) {
      dispatch(refreshCategData());
    }

    // if (found) {
    //   updateProductToDatalayer(found.product, Math.abs(diffQty), diffQty > 0 ? 'addToBasket' : 'removeToBasket');
    // }

    if (entity.status.showConfirm && !isWineBox) {
      const showGoToCart = true;
      const name = found.wineBox ? t(`${getWineboxName(found.product.primeur)}`) : found.product.productName;
      const message = t(`product.${key}`).replace('{0}', name);
      const boxCustomizable = content.products.every((element) => getIsCustomizable(element));
      const wineboxIsAddedToCart = content?.products?.some((product) => product.wineBox);
      let continueShoppingCallback;

      if (key === 'addedToCart' && wineboxIsAddedToCart) {
        continueShoppingCallback = () => {
          dispatch(refreshCategData());
        };
      }
      dispatch(showRecommendationModal({
        content: message,
        button: 'product.continueShopping',
        showGoToCartBtn: showGoToCart,
        currentBox: diffPartnumber?.includes(CART_TYPE.BOX) ? ({ id: diffPartnumber, isCustomizable: boxCustomizable }) : {},
        continueShoppingCallback,
      }));
    }

    return true;
  }, [cart]);

  useEffect(() => {
    if (processAddStatus(cart)) {
      dispatch(addCartProductClear());
    }
  }, [cart, cart.status.add, processAddStatus]);

  useEffect(() => {
    if (processAddStatus(box)) {
      dispatch(addBoxProductClear());
    }
  }, [box, box.status.add, processAddStatus]);

  return null;
};

export default CartAndBoxEventsProcess;
